import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PublicFormPage from "./components/PublicFormPage";
import PublicInspectionPage from "./components/PublicInspectionPage";

// Ruteo manual muy simple: /f/<token> muestra el formulario público (sin
// login), cualquier otra ruta carga la app normal. No se usa react-router
// porque solo existe esta única ruta pública.
const redirectedPath = new URLSearchParams(window.location.search).get("redirect_path");
const effectivePath = redirectedPath || window.location.pathname;
const publicMatch = effectivePath.match(/^\/f\/([^/]+)$/);
const publicToken = new URLSearchParams(window.location.search).get("public_form_token");
const publicInspectionToken = new URLSearchParams(window.location.search).get("public_inspection_token");

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {publicInspectionToken ? <PublicInspectionPage token={publicInspectionToken} /> : publicMatch || publicToken ? <PublicFormPage token={publicMatch?.[1] || publicToken} /> : <App />}
  </React.StrictMode>
);
